import angular from 'angular';
import gaugeProgressBarComponent from './gauge-progress-bar.component';

let gaugeProgressBarModule = angular.module('tcGaugeProgressBar', [])
  .component('tcGaugeProgressBar', gaugeProgressBarComponent);

export default gaugeProgressBarModule;




// WEBPACK FOOTER //
// ./client/common/directives/gauge-progress-bar/gauge-progress-bar.js